module.exports = {"HostName":"https://backend.hcl-ancestry.com","TimeOut":90000}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = 10
// module chunks = 0